// src/properties/adminListingsApi.ts
import { apiClient } from "@maat/api-base";
var adminListingsApi = {
  list: async (params) => {
    return apiClient.get("/main/api/admin/listings", {
      params,
      paramsSerializer: { indexes: null }
    });
  },
  /**
   * One endpoint, both inventory kinds. Narrow the result on
   * `inventory_kind` (`isAdminSlotListingDetail`) — never on which fields are
   * present, since a stay has no inventory row and a slot listing has no
   * property, and both absences are legitimate.
   */
  getListing: async (id) => {
    return apiClient.get(`/main/api/admin/listings/${id}`);
  },
  getListingImages: async (id) => {
    return apiClient.get(`/main/api/admin/listings/${id}/images`);
  },
  setListingSuspension: async (id, body) => {
    return apiClient.patch(`/main/api/admin/listings/${id}/suspension`, body);
  },
  /** The review queue: stays waiting on, or refused by, a human, plus the KPI strip. */
  listModeration: async (params) => {
    return apiClient.get("/main/api/admin/listings/moderation", { params });
  },
  /** Approve or reject. A rejection needs a note — the host is shown it verbatim. */
  reviewListing: async (id, body) => {
    return apiClient.post(`/main/api/admin/listings/${id}/moderation`, body);
  },
  updatePricing: async (id, body) => {
    return apiClient.patch(`/main/api/admin/listings/${id}/pricing`, body);
  },
  updateAmenities: async (id, body) => {
    return apiClient.patch(`/main/api/admin/listings/${id}/amenities`, body);
  },
  updateUnitDetails: async (id, body) => {
    return apiClient.patch(`/main/api/admin/listings/${id}/unit-details`, body);
  },
  listModerationImages: async (params) => {
    return apiClient.get("/main/api/admin/images/moderation", {
      params,
      paramsSerializer: { indexes: null }
    });
  },
  publishImage: async (imageId, body) => {
    return apiClient.post(`/main/api/admin/images/${imageId}/publish`, body ?? {});
  },
  rejectImage: async (imageId, body) => {
    return apiClient.post(`/main/api/admin/images/${imageId}/reject`, body ?? {});
  }
};

export {
  adminListingsApi
};
